export enum RncpFilterField {
  TYPE_CERTIFICATION = 'TYPE_CERTIFICATION',
  NIVEAU_CERTIFICATION = 'NIVEAU_CERTIFICATION',
}